module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "resumeEditor"
    }
  }, [_c('nav', [_c('ol', _vm._l((_vm.resumeConfig), function(item, index) {
    return _c('li', {
      class: {
        active: item.field === _vm.selected
      },
      on: {
        "click": function($event) {
          _vm.selected = item.field
        }
      }
    }, [_c('svg', {
      staticClass: "icon"
    }, [_c('use', {
      attrs: {
        "xlink:href": ("#icon-" + (item.icon))
      }
    })])])
  }))]), _vm._v(" "), _c('ol', {
    staticClass: "panels"
  }, _vm._l((_vm.resumeConfig), function(item) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.field === _vm.selected),
        expression: "item.field === selected"
      }]
    }, [(item.type === 'array') ? _c('div', [_vm._l((_vm.resume[item.field]), function(subitem, i) {
      return _c('div', {
        staticClass: "subitem"
      }, [_vm._l((subitem), function(value, key) {
        return _c('div', {
          staticClass: "resumeField"
        }, [_c('label', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('input', {
          attrs: {
            "type": "text"
          },
          domProps: {
            "value": value
          },
          on: {
            "input": function($event) {
              _vm.changeResumeFiled(((item.field) + "." + i + "." + key), $event.target.value)
            }
          }
        })])
      }), _vm._v(" "), _c('button', {
        staticClass: "delThis",
        on: {
          "click": function($event) {
            _vm.delResumeField(((item.field) + "." + i))
          }
        }
      }, [_vm._v("删除")]), _vm._v(" "), _c('hr')], 2)
    }), _vm._v(" "), _c('button', {
      staticClass: "addNew",
      on: {
        "click": function($event) {
          _vm.addResumeSubfield(item.field)
        }
      }
    }, [_vm._v("新增")])], 2) : _vm._l((_vm.resume[item.field]), function(value, key) {
      return _c('div', {
        staticClass: "resumeField"
      }, [_c('label', [_vm._v(" " + _vm._s(key))]), _vm._v(" "), _c('input', {
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": value
        },
        on: {
          "input": function($event) {
            _vm.changeResumeFiled(((item.field) + "." + key), $event.target.value)
          }
        }
      })])
    })], 2)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-53358100"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResumeEditor.vue
// module id = 79
// module chunks = 1